import React, { useState } from "react";
import { connect } from "react-redux";
import { Container, Content, Text, Title, i18n, tokens, Button, Theme } from "@simplybenefits/sb-ui-library";
import Grid from "@mui/material/Grid";
import { Launch } from "@mui/icons-material";
import EnrichedAcademyModal from "../../components/EnrichedAcademyModal.js";
import pocketPillsImage from "../../assets/pocketpills-icon.png";
import enrichedAcademyImage from "../../assets/enriched-academy-icon.png";

/**
 * 
 * @param {*} title
 * @param {*} isIncludedInPlan
 * @param {*} icon
 * @param {*} description
 * @param {*} navigation
 * @param {*} whitelabel
 * @returns 
 */
const Tile = ({ title, isIncludedInPlan = false, icon, description, navigation, whitelabel = {} }) => {
    const styles = {
        container: {
            display: "flex", 
            flexDirection: "column",
            height: "100%",
            backgroundColor: Theme.colors.surface,
            border: `1px solid ${ Theme.colors.lightGrey }`,
            borderRadius: 6
        },
        descriptionContainer: {
            paddingRight: 27,
            paddingLeft: 40,
            paddingTop: 19,
            marginBottom: 24,
            flexGrow: 1
        },
        titleContainer: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 14
        },
        icon: { 
            width: 50,
            height: 50,
            marginRight: 20 
        },
        subTitle: {
            color: whitelabel.primaryColor || Theme.colors.skyBlue,
            borderRadius: 20,
            backgroundColor: whitelabel.lightColor || Theme.colors.lightBlue,
            paddingRight: 7,
            paddingLeft: 7,
            display: "inline-block"
        },
        divider: {
            borderBottom: `1px solid ${ Theme.colors.lightGrey }`
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            height: 50,
            marginRight: 13
        },
        buttonIcon: {
            width: 15,
            height: 15,
            marginRight: 5,
            color: whitelabel.primaryColor || Theme.colors.skyBlue 
        }
    };

    /**
     * @param {*} destination
     */
    const _handleNavigation = (destination) => {
        if (typeof destination === "function") {
            destination();
        } else {
            window.open(destination, "_blank");
        }
    };

    return (
        <Grid item xs={12} md={6} lg={4} xl={4}>
            <div style={ styles.container }>
                <div style={ styles.descriptionContainer }>
                    <div style={ styles.titleContainer }>
                        <img src={ icon } style={ styles.icon }/>
                        <div>
                            <Text medium bold>{ title }</Text>
                            {
                                isIncludedInPlan ?
                                    <Text
                                        superTiny
                                        bold 
                                        customStyle={ styles.subTitle }
                                    >
                                        { i18n.t(tokens.labels.perks.includedInYourPlan) }
                                    </Text>
                                    : null
                            }
                        </div>
                    </div>
                    <Text>{ description }</Text>
                </div>
                <div style={ styles.divider }/>
                <div style={ styles.buttonContainer }>
                    <Button 
                        transparent
                        noHover
                        onClick={() => _handleNavigation(navigation)}
                    >
                        <Launch style={ styles.buttonIcon }/>
                        <Text
                            small
                            bold
                            color={ whitelabel.primaryColor || Theme.colors.skyBlue}
                        >
                            { i18n.t(tokens.labels.perks.viewProduct) }
                        </Text>
                    </Button>
                </div>
            </div>
        </Grid>
    );
};

/**
 * 
 * @param {*} coverage
 * @param {*} user
 * @param {*} whitelabel 
 * @returns 
 */
const Perks = ({ coverage, user, whitelabel }) => {
    const [ showEnrichedAcademyModal, setShowEnrichedAcademyModal ] = useState(false);
    const showEnrichedAcademy = !user.isDependent
                                && coverage.financialAwareness.benefitActive === 1
                                && coverage.financialAwareness.isEligible === 1
                                && coverage.financialAwareness.includeEnrichedAcademy === 1;

    const pocketPillsUrl = i18n.locale === 'fr' ? "https://www.pocketpills.com/fr/simplybenefits" : "https://www.pocketpills.com/simplybenefits";

    /**
     * 
     */
    const _toggleEnrichedAcademyModal = () => {
        setShowEnrichedAcademyModal((prev) => !prev);
    };
    
    return (
        <Container>
            <Content>
                <Title title={ i18n.t(tokens.labels.perks.simplyPerks) } />
                <Text medium>{ i18n.t(tokens.labels.perks.enjoyExclusiveOffers) }</Text>
                <Grid container columnSpacing={ 4.5 } rowSpacing={ 4.25 } style={{ marginTop: -10 }}>
                    {
                        showEnrichedAcademy ?
                            <Tile
                                title="Enriched Academy"
                                isIncludedInPlan
                                icon={ enrichedAcademyImage }
                                description={ i18n.t(tokens.labels.perks.enrichedAcademyDescription) }
                                navigation={ _toggleEnrichedAcademyModal }
                                whitelabel={ whitelabel }
                            />
                            : null
                    }

                    <Tile
                        title="Pocketpills"
                        icon={ pocketPillsImage }
                        description={ i18n.t(tokens.labels.perks.pocketPillsDescription) }
                        navigation={ pocketPillsUrl }
                        whitelabel={ whitelabel }
                    />
                </Grid>

                {
                    showEnrichedAcademyModal ?
                        <EnrichedAcademyModal 
                            open={ showEnrichedAcademyModal } 
                            toggleOpen={ _toggleEnrichedAcademyModal } 
                            user={ user }
                        />
                        : null
                }
            </Content>
        </Container>
    );
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    coverage: state.coverage.data,
    user: state.user,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(Perks);